module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top'), _vm._v(" "), _c('main', [_c('container', [(!_vm.done) ? _c('loader') : _vm._e(), _vm._v(" "), _vm._l((_vm.books), function(list, language) {
    return (_vm.done) ? _c('row', [_c('div', {
      staticClass: "col s12"
    }, [_c('ul', {
      staticClass: "collection with-header"
    }, [_c('li', {
      staticClass: "collection-header"
    }, [_c('h4', [_vm._v(_vm._s(language))])]), _vm._v(" "), _vm._l((list), function(book) {
      return _c('li', {
        staticClass: "collection-item"
      }, [(book.ID) ? _c('div', [_vm._v("\n                                " + _vm._s(book.Title) + "\n                                "), _c('small', [_vm._v(_vm._s(book.Author))]), _vm._v(" "), _c('router-link', {
        staticClass: "secondary-content",
        attrs: {
          "to": {
            name: 'book',
            params: {
              id: book.ID
            }
          }
        }
      }, [_c('i', {
        staticClass: "material-icons"
      }, [_vm._v("send")])])], 1) : _vm._e()])
    })], 2)])]) : _vm._e()
  })], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2064e5fe!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Books.vue
// module id = 72
// module chunks = 0